// src/components/RouteChangeTracker.js
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

const RouteChangeTracker = () => {
  const location = useLocation();
  const [initialized, setInitialized] = useState(false);

  // Initialize GA4
  useEffect(() => {
    ReactGA.initialize("G-XQ0KV0HZ8B");
    setInitialized(true);
  }, []);

  // Track page views
  useEffect(() => {
    if (initialized) {
      ReactGA.send({
        hitType: "pageview",
        page: location.pathname + location.search,
      });
    }
  }, [initialized, location]);

  return null; // This component does not render anything
};

export default RouteChangeTracker;
